/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductSalesfor1997RoutingModule
 * Purpose		: Routing module for ProductSalesfor1997.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ProductSalesfor1997ListComponent } from './ProductSalesfor1997List.component';
import { ProductSalesfor1997DetailsComponent } from './ProductSalesfor1997Details.component';

const ProductSalesfor1997Routes: Routes = [
	{ path: 'ProductSalesfor1997',  component: ProductSalesfor1997ListComponent },
	{ path: 'ProductSalesfor1997/Details/:id', component: ProductSalesfor1997DetailsComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(ProductSalesfor1997Routes)
  ],
  exports: [
    RouterModule
  ]
})

export class ProductSalesfor1997RoutingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/ProductSalesfor1997/ProductSalesfor1997-routing.module.ts